export function LayerProgress({ progress, fallback }) {
  if (!progress && !fallback) return null;
  const lines = progress?.lines || [];
  if (!lines.length && fallback) {
    return (
      <div className="text-[11px] space-y-0.5" style={{ color: "var(--hoip-text-tertiary)" }} data-testid="layer-progress">
        <div>{fallback}</div>
      </div>
    );
  }
  if (!lines.length) return null;
  return (
    <div className="text-[11px] space-y-0.5 leading-snug" style={{ color: "var(--hoip-text-secondary)" }} data-testid="layer-progress">
      {lines.map((ln, i) => (
        <div key={i} className={i === 0 ? "font-medium" : ""}>{ln}</div>
      ))}
    </div>
  );
}
